import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { showToast } from 'shared/ui'
import { logger } from 'shared/lib'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { CustomFieldApi } from 'entities/CustomField/api'

export const deleteCustomFieldAction = (id: number, onSuccess: () => Promise<void>) => {
  const modalId = nanoid()

  const closeModal = () => {
    modalStore.removeModal(modalId)
  }

  const confirmDelete = async () => {
    try {
      await CustomFieldApi.deleteCustomField(id)
    } catch (error) {
      logger.error(error)

      showToast({
        type: 'error',
        title: 'Something went wrong. Please try again',
      })

      return
    }

    closeModal()

    showToast({
      type: 'success',
      title: 'Custom field deleted',
    })

    await onSuccess()
  }

  modalStore.addModal({
    id: modalId,
    showHeader: true,
    showCloseButton: false,
    showCloseIcon: false,
    width: 280,
    onClose: closeModal,
    title: 'Delete custom field?',
    desc: 'This action cannot be undone.',
    type: ModalTypeList.ALERT,
    secondaryAction: {
      text: 'Cancel',
      onAction: closeModal,
    },
    primaryAction: {
      text: 'Delete',
      onAction: confirmDelete,
    },
  })
}
